
export abstract class RespostaMarcacaoDTO {

    resposta: string;

    constructor(resposta: string) {
        this.resposta = resposta;
    }
}
